import * as React from "react";
import { useTranslations } from "../i18n/useTranslations";
import { ArrowForward } from "../icons/ArrowForward";
import { useUser } from "../user/useUser";

export const DDProBanner: React.FunctionComponent = () => {
  const { t } = useTranslations();
  const { clinicName } = useUser();
  const onClick = () => (document.location.href = "/pro");

  return (
    <div className="elm-bg-dd-green-200 elm-px-6 elm-py-7 elm--mx-6 elm--mt-2 md:elm--mx-12 md:elm-px-12 md:elm--mt-12 elm-mb-4 elm-flex elm-flex-row elm-justify-between">
      <div>
        <div role="heading" className="elm-text-dd-green-900 elm-font-semibold elm-m-0 elm-text-lg">
          DD PRO
        </div>
        <div
          role="heading"
          className="elm-text-dd-gray-900 elm-font-semibold elm-opacity-80 elm-mx-0 elm-my-1 elm-text-2xl"
        >
          {clinicName}
        </div>
        <div className="elm-text-dd-gray-900">{t("Access admin dashboard")}</div>
      </div>
      <div className="elm-flex elm-items-end">
        <a
          tabIndex={0}
          data-track-label={`btn:dd-pro:go:from:user`}
          className="elm-bg-white elm-border-0 elm-cursor-pointer elm-flex elm-h-10 elm-items-center elm-justify-center elm-pointer-events-auto elm-px-0 elm-py-2 elm-rounded-full elm-w-10 focus:elm-outline-none lg:hover:elm-bg-dd-green-200"
          onClick={onClick}
          title={t("DD Pro")}
          aria-label={t("DD Pro")}
        >
          <ArrowForward />
        </a>
      </div>
    </div>
  );
};
